"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgCircle(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 0 16 24" }, props),
        React.createElement("path", { d: "M12 4a2 2 0 011.854 1.248 7.013 7.013 0 014.898 4.898 2 2 0 010 3.708 7.013 7.013 0 01-4.898 4.898 2 2 0 01-3.708 0 7.013 7.013 0 01-4.898-4.898 2 2 0 010-3.708 7.015 7.015 0 014.898-4.898A2 2 0 0112 4zm1.56 3.248l-.05.064a2 2 0 01-3.071-.062 5.004 5.004 0 00-3.19 3.19 1.995 1.995 0 01.001 3.121 5.004 5.004 0 003.19 3.19 1.995 1.995 0 013.121-.001 5.004 5.004 0 003.19-3.19 1.995 1.995 0 01-.001-3.121 5.004 5.004 0 00-3.19-3.19z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Circle')(SvgCircle);
//# sourceMappingURL=Circle.js.map